import { render, staticRenderFns } from "./SecondaryPagesBackground.vue?vue&type=template&id=315d8e6f&scoped=true&"
import script from "./SecondaryPagesBackground.vue?vue&type=script&lang=js&"
export * from "./SecondaryPagesBackground.vue?vue&type=script&lang=js&"
import style0 from "./SecondaryPagesBackground.vue?vue&type=style&index=0&id=315d8e6f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315d8e6f",
  null
  
)

export default component.exports